export const cutBigString = (str, maxLength) => str.length > maxLength ? `${str.slice(0, maxLength)}...` : str;
